import PointMarker from './PointMarker';
import BorderMarker from './BorderMarker';
import { FC, useEffect, useState } from 'react';
import { useStadiometry } from '@/common/hook/Amap/useStadiometry';
import useLatest from '@/common/hook/useLatest';
import { businessStatus } from '../../ts-config';
export const pointMarkerZIndex = 10;

/**
 * @Description 元素交互点击
 */
const MarkerCon: FC<{
  pointListRef,
  newPointData,
  allPolygonData,
  newPolygonData,
  mapIns,
  curSelectRef,
  hasClickRef,
  isShapeRef,
  allPointDataRef,
  setItemData,
  polygonListRef,
  itemData,
  // pointData,
  // polygonData,
  locationInfo,
  allPointData,
  targetZoomNamesMarkerRef, // 指定缩放区域时显示的所有的name的覆盖物
  curZoom, // 当前缩放级别
  viewAreaData, // 可视区域内的开店区域数据
  isBatchCollect, // 是否是批量收藏状态收藏
  batchCollectIds, // 批量收藏的开店区域id
  setBatchCollectIds, // 设置批量收藏的开店区域id
  cityProvinceInfo, // 左上角城市信息
}> = ({
  pointListRef,
  newPointData,
  allPolygonData,
  newPolygonData,
  mapIns,
  curSelectRef,
  hasClickRef,
  isShapeRef,
  allPointDataRef,
  setItemData,
  polygonListRef,
  itemData,
  // pointData,
  // polygonData,
  locationInfo,
  allPointData,
  targetZoomNamesMarkerRef, // 指定缩放区域时显示的所有的name的覆盖物
  curZoom, // 当前缩放级别
  viewAreaData, // 可视区域内的开店区域数据
  isBatchCollect, // 是否是批量收藏状态收藏
  batchCollectIds, // 批量收藏的开店区域id
  setBatchCollectIds, // 设置批量收藏的开店区域id
}) => {
  const isStadiometry: any = useStadiometry(); // 是否在使用测距功能
  const isStadiometryRef = useLatest(isStadiometry);
  const allPolygonDataRef = useLatest(allPolygonData);

  const [hoverPolygonId, setHoverPolygonId] = useState<number>(0);// hover围栏时，需要把对应的点位变成hover状态

  const polygonColor = (value) => {
    // if (value?.isFavourate) return '#6236FF';
    if (value?.userCustomFlag) return '#009963';
    return '#006aff';
  };
  const handleImg = (isSelect) => {
    let img = `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_point_img.png`;
    if (isSelect) {
      img = `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_point_selected.png`;
    }
    return img;
  };

  // 开店区域样式
  const pointStyle = (value, isSelect) => {
    if (value.status === businessStatus.NEW) {
      return `<div class="${isSelect ? 'label selectLabel' : 'label'}">
        <div class="${isSelect ? 'selectTriangle triangle' : 'triangle'}"></div>
    <div class="name">
    <span class="areaName">${value.areaName}</span>
    <span>新增生成中</span>
    </div>
        </div>`;
    }

    if (value.rank >= 200) {
      return `<div class="${isSelect ? 'orangeCirclePoint' : 'blueCirclePoint'}"></div>`;
    }

    return `<div class="pointCon">
        <div class='${isSelect ? 'iconOrangeText' : 'iconBlueText'}'>${value.rank + 1}</div>
        <img src='${handleImg(isSelect)}'/>
      </div>`;
  };
  const clickAddressMarker = (item) => {
    if (isShapeRef.current) return;
    // 在使用工具箱的测距功能时，不执行选中/取消商圈的逻辑
    if (isStadiometryRef.current) return;
    // 去匹配到pointData中对应数据的id，然后去该项作为item
    let curValue: any = null;
    allPointDataRef.current.map((cur) => {
      if (cur?.id === item.id) {
        curValue = cur;
      }
    });
    // 工具箱使用中时不支持点击打开详情
    if (recover(item)) {
      // 设置detail，detail会触发useEffect 去执行对应的方法
      // debugger;
      setItemData({
        id: curValue?.id,
        detail: curValue,
        visible: true,
        isFirst: false
      });
    }
  };
    // 绘制选中样式
  const drawSelected = (item) => {
    let pointMarker = null;
    // 绘制下一个item
    pointListRef.current.map((addressMarker) => {
      if (addressMarker.getExtData()?.id === item?.id) {
        addressMarker.setContent(pointStyle(item, true));
        addressMarker.setzIndex(pointMarkerZIndex + 1);
        pointMarker = addressMarker;
      }
    });

    let border = null;
    polygonListRef.current.map((polygonMarker) => {
      if (polygonMarker.getExtData()?.id === item?.id) {
        border = polygonMarker;
        polygonMarker.setOptions({
          strokeColor: '#FC7657',
          fillColor: '#FC7657',
        });
      }
    });

    if (curSelectRef.current?.id !== itemData.id) {
      if (border) {
        mapIns.setFitView(border);
      } else {
        +item?.lng && +item?.lat && mapIns.setZoomAndCenter(17, [+item?.lng, +item?.lat], 100);
      }
    }

    // 在将这个item赋值给curSelectedRef
    curSelectRef.current = {
      ...item,
      border,
      pointMarker,
    };
  };
  // 恢复被选中样式，且返回true、false表示是否往下执行
  const recover = (item) => {
    // 先恢复上一次的item，此时curSelectedRef未重新赋值，所以还是上一次的
    if (curSelectRef.current?.id === 0 || curSelectRef.current?.id) {
      pointListRef.current.map((addressMarker) => {
        if (addressMarker.getExtData()?.id === curSelectRef.current.id) {
          addressMarker.setContent(pointStyle(addressMarker.getExtData(), false));
          addressMarker.setzIndex(pointMarkerZIndex);
        }
      });
      // 这里可能会拿到旧的数据，所以需要从allPolygonData中再遍历得到新数据
      const value = allPolygonDataRef.current?.find((item) => item.id === curSelectRef.current?.id);
      curSelectRef.current?.border?.setOptions({
        strokeColor: polygonColor(value),
        fillColor: polygonColor(value),
      });
    }
    // 取消选中
    if (curSelectRef.current?.id === item?.id && curSelectRef.current?.id) {
      curSelectRef.current = null;
      setItemData({
        id: null,
        detail: null,
        visible: false,
        isFirst: false
      });
      return false;
    } else if (!item?.id) {
      curSelectRef.current = null;
    }
    return true;
  };

  // 处理地图点击事件，响应到围栏上
  const handleMapClick = (e) => {
    if (hasClickRef.current) {
      hasClickRef.current = false;
      return;
    }
    let isFlag = false;

    polygonListRef.current.map((polygon) => {
      if (isFlag) return;
      if (polygon.contains([e.lnglat.lng, e.lnglat.lat])) {
        isFlag = true;
        // 此时pointRef还没有显示出来，所以需要延迟100ms
        setTimeout(() => {
          clickAddressMarker(polygon.getExtData());
        }, 100);
      }
    });
  };

  useEffect(() => {
    if (!mapIns) return;
    if (itemData.visible) {
      if (curSelectRef.current?.id !== itemData?.id) {
        recover(itemData.detail);
      }
      // 存在该值才绘制
      drawSelected(itemData.detail);
    } else {
      // detail为null，则对应的index也不存在
      recover(itemData.detail);
    }
  }, [itemData, newPointData, newPolygonData]);

  useEffect(() => {
    if (!mapIns) return;
    mapIns.on('click', handleMapClick);
    return () => {
      mapIns.off('click', handleMapClick);
    };
  }, [mapIns]);

  return <>
    <PointMarker
      newPointData={newPointData}
      pointStyle={pointStyle}
      mapIns={mapIns}
      curSelectRef={curSelectRef}
      hasClickRef={hasClickRef}
      clickAddressMarker={clickAddressMarker}
      pointListRef={pointListRef}
      // setItemData={setItemData}
      allPointData={allPointData}
      locationInfo={locationInfo}
      targetZoomNamesMarkerRef={targetZoomNamesMarkerRef}
      curZoom={curZoom}
      viewAreaData={viewAreaData}
      hoverPolygonId={hoverPolygonId}
      setHoverPolygonId={setHoverPolygonId}
      isBatchCollect={isBatchCollect}
      batchCollectIds={batchCollectIds}
      setBatchCollectIds={setBatchCollectIds}
    />
    <BorderMarker
      newPolygonData={newPolygonData}
      mapIns={mapIns}
      polygonListRef={polygonListRef}
      setHoverPolygonId={setHoverPolygonId}
      polygonColor={polygonColor}
    />
  </>;
};
export default MarkerCon;
